<app-header *ngIf="readLocalStorageValue() && !ocultarPie"></app-header>
<ngx-spinner
    bdColor="rgba(51,51,51,0.8)"
    size="medium"
    color="#288600"
    type="ball-clip-rotate-pulse">
    <p style="font-size: 20px; color: white">Cargando datos...</p>
</ngx-spinner>
<app-main></app-main>
<app-footer *ngIf="!ocultarPie"></app-footer>